import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';

import { RemoteAutoComplete, RemoteAutoCompleteField } from '@components/form';

const View: React.SFC<any> = ({ editable }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        {[
          { name: 'sequenceTicketBnp', label: 'Číselná řada BNP' },
          { name: 'sequenceTicketBnz', label: 'Číselná řada BNZ' },
          { name: 'sequenceTicketRebuke', label: 'Číselná řada domluv' },
          { name: 'sequenceNoticeTicket', label: 'Číselná řada stěračenky' },
          { name: 'sequenceEvent', label: 'Číselná řada událostí' },
          { name: 'sequenceDelict', label: 'Číselná řada přestupků' },
          { name: 'sequenceTask', label: 'Číselná řada úkolů' },
          { name: 'sequenceProtocolIssue', label: 'Číselná řada výdejek' },
          { name: 'sequenceProtocolReceipt', label: 'Číselná řada příjemek' },
          { name: 'sequenceProtocolProcurement', label: 'Číselná řada dodejek' },
          { name: 'sequenceProtocolTransfer', label: 'Číselná řada převodky' },
          { name: 'sequenceProtocolDisposal', label: 'Číselná řada likvidací' },
          { name: 'sequenceRepair', label: 'Číselná řada oprav/údržeb' },
          { name: 'sequenceInventoryCard', label: 'Číselná řada skladových karet' },
          { name: 'sequenceOwaGeneralItem', label: 'Číselná řada předmětů v operačním skladu'},
          { name: 'sequenceOwaClamp', label: 'Číselná řada botiček v operačním skladu'}
        ].map((field, id) => (
          <Col md={6} key={id}>
            <Row className={id % 2 ? '' : 'with-right-divider'}>
              <Col md={12}>
                <RemoteAutoCompleteField
                  component={RemoteAutoComplete}
                  id={field.name}
                  name={`sequenceSettings.${field.name}`}
                  filterActive={true}
                  label={field.label}
                  disabled={!editable}
                  caching={true}
                  url="/metropolis/api/sequences"
                  labelFunction={o => get(o, 'name')}
                />
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Grid>
    <Divider />
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/generalSettings/GeneralSettingsFormNumberSequences.tsx